import styles from './widgetCard.module.css'
import { Spinner } from '../../../../../features/ui'
import { useNavigate } from 'react-router-dom'
import { useRoutesHooks, RoutePath } from '../../../../../features/routes'

type Props = {
    title: string
    loading?: boolean
    error?: boolean
    empty?: boolean
    emptyLabel?: string
    linkLabel?: string
    linkPath?: string
    // Controls shown on the header line, to the right of the title (e.g. a filter)
    headerActions?: React.ReactNode
    children?: React.ReactNode
}

export const WidgetCard = (props: Props) => {
    const { title, loading, error, empty, emptyLabel = 'Sin datos', linkLabel, linkPath, headerActions, children } = props
    const navigate = useNavigate()
    const { getRoutePath } = useRoutesHooks()

    const onLinkClick = () => {
        if (linkPath) navigate(getRoutePath(linkPath as RoutePath))
    }

    return (
        <div className={`card h-100 ${styles.widget}`}>
            <div className={`card-body ${styles.body}`}>
                <div className={styles.header}>
                    <h5 className={styles.title}>{title}</h5>
                    {headerActions}
                    {linkLabel && linkPath && (
                        <span className={styles.link} onClick={onLinkClick}>{linkLabel} →</span>
                    )}
                </div>
                {loading && <Spinner size="s" />}
                {!loading && error && <p className="text-danger small mb-0">Error al cargar. Intentá actualizar la página.</p>}
                {!loading && !error && empty && <p className={styles.empty}>{emptyLabel}</p>}
                {!loading && !error && !empty && children}
            </div>
        </div>
    )
}
